import { render, staticRenderFns } from "./ad.vue?vue&type=template&id=63fb8ef4&scoped=true&"
import script from "./ad.vue?vue&type=script&lang=js&"
export * from "./ad.vue?vue&type=script&lang=js&"
import style0 from "./ad.vue?vue&type=style&index=0&id=63fb8ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb8ef4",
  null
  
)

export default component.exports